
import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';
import { DiagramEngine } from '@projectstorm/react-diagrams-core';
import UserIntentWidget from '../../../ui/editor/widget/UserIntentWidget/UserIntentWidget';
import NodeTypes from '../NodeTypes';
import { PortModel } from './PortModel';
import BasePort from '../../../ui/editor/port/basePort/BasePort';
import PortTypes from '../PortTypes';

export class PortFactory extends AbstractReactFactory<PortModel, DiagramEngine> {
  constructor() {
    super(PortTypes.basePort);
  }

  generateModel(initialConfig:any) {
    return new PortModel(initialConfig);
  }

  generateReactWidget(event:any): JSX.Element {
    return <BasePort engine={this.engine as DiagramEngine} port={event.model} style={{}}/>;
  }
}

